// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			//suggestionMode: 'test',
			//suggestionPosition: 'left'
	},
  	general: {
		enableAjaxCart: true,
		enableAjaxCartOnProductPage: true,
      	// showAjaxCartOnAdd: true,
	},
	selector: {
		productPageAtcButton: 'form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] *[name="add"]',
		productPageAtcForm: 'form[action="/cart/add"]',
	}
};

(function() {
	BoostPFS.inject(this);

    // setTimeout(function(){
    //   if (!Utils.isCollectionPage() && !Utils.isSearchPage()) {
    //    BoostOTP.init();
    //   }  	
    // }, 500)
    
    var productTemplate = InstantSearchResultItemProduct.prototype.getTemplate;
    InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
      if (tempType) return productTemplate.call(this, tempType);

        return '<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}">' +
                      '<a href="{{url}}" {{newTabAttribute}}>' + 
                          '{{itemProductImage}}' + 
                          '<div class="{{class.searchSuggestion}}-right">' + 
                              '<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>' + 
                              '{{itemProductSku}}' + 
                              '{{itemProductVendor}}' + 
                              '{{itemStock}}' +         
                              '{{itemProductPrice}}' + 
                          '</div>' + 
                      '</a>' + 
                  '</li>';
    }

    var productCompile = InstantSearchResultItemProduct.prototype.compileTemplate;
    InstantSearchResultItemProduct.prototype.compileTemplate = function() {  
      if (!this.isShow) return '';      

      var itemHtml = productCompile.call(this);
      
      var pCounterQty = 0;
      var pVariants = this.data.variants;
      pVariants.forEach(function(item){
        pCounterQty = pCounterQty + item.inventory_quantity;
      });
      itemHtml = itemHtml.replace(/{{itemProductPrice}}/,  buildprice(this.data))
      itemHtml = pCounterQty > 0 ? itemHtml.replace(/{{itemStock}}/g, "In Stock") : itemHtml.replace(/{{itemStock}}/g, "Pre-Order");
     
      return itemHtml;
    }
    if (Utils.isCollectionPage() || Utils.isSearchPage()) {
      BoostOTP.AjaxCart.prototype.onSucess = function(data, $addingLabel, $errorLabel, addToCartLabel = Labels.action_list.atcAvailableLabel) {
            this.changeButtonLabel($addingLabel, Labels.action_list.atcAddingToCartBtnLabel, Labels.action_list.atcAddedToCartBtnLabel);
            setTimeout(() => {
                this.changeButtonLabel($addingLabel, Labels.action_list.atcAddedToCartBtnLabel, addToCartLabel);
            }, 700);
            var isOpenCart = Settings.getSettingValue('general.showAjaxCartOnAdd');
            if(Settings.getSettingValue('general.ajaxCartStyle') === 'none') {
                isOpenCart = false;
            }
            this.getCart(isOpenCart);
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then((response) => response.text())
              .then((responseText) => {
                const cartDrawerElm = document.querySelector("cart-drawer");
                const html = new DOMParser().parseFromString(responseText, "text/html");
                const newCartDrawerHTML = html.querySelector("#CartDrawer").innerHTML;
                cartDrawerElm.querySelector("#CartDrawer").innerHTML = newCartDrawerHTML;
                cartDrawerElm.classList.remove("is-empty");
                cartDrawerElm.open();
            });
        }
  
  
   
      BoostOTP.AjaxCartOnProductPage.prototype.onClickAddToCart = function(e) {
  		if (e) {
  			e.stopPropagation();
  			e.preventDefault();
  		}
    		var formData = this.$form.serializeArray();
  		var variantId = 0;
  		var quantity = 1;
  		formData.forEach(entry => {
  			if (entry.name == "id") {
  				variantId = entry.value;
  			} else if (entry.name == 'quantity') {
  				quantity = entry.value;
  			}
  		})
          AjaxCart.instance.addToCart(variantId, quantity, this.$addingLabel, this.$errorLabel);
      	if(boostPFSAppConfig.general.template === 'product' && this.$form.hasClass('product-form')) {
            setTimeout(() => {
                if(jQ('.warranty input:checked').parent().find('form').length > 0) {
                  jQ('.warranty input:checked').parent().find('form button[type="submit"]').click();
                }
            }, 500);
          }
      }
      
      BoostOTP.AjaxCartOnProductPage.prototype.afterBindEvents = function(){
        if(boostPFSAppConfig.general.template === 'product' ) {
          var _this = this;
          jQ('form.product-form button[type="submit"]').each(function() {
              jQ(this).off('click').on('click', _this.onClickAddToCart.bind(_this));                                                   
          });
        }
      }
    }
    
    
	
    /*
    function buildprice(data) {
      var html = '';              
              
              var msrp = Utils.getProductMetafield(data, 'TownApplianceAPI', 'msrp');//(msrp metafield) /// List price
              if (msrp != null) {
                msrp = msrp.replace(/\$/g, '').replace(/,/g, '')
                msrp = msrp*1;
              }
             
              var map_no_promos =  data.compare_at_price_min // Sale price
			  var paFpv = Utils.getProductMetafield(data, 'TownApplianceAPI', 'pafpv_price');// website price (metafield)
              if (paFpv != null) {
                paFpv =  paFpv.replace(/\$/g, '').replace(/,/g, '')
                paFpv =  paFpv*1;
              }
              var inCartFpv = data.price_min ///checkout price (native shopify price field)
              var isLower = false;
              paFpv;
              
              if (inCartFpv < paFpv) { 
                 isLower = true;
              }
                              
              if (data.compare_at_price_min > data.price_min) {
                  if (msrp != null && msrp > map_no_promos ) html += '<div class="boost-list-price"><span>List price: </span><s>' + Utils.formatMoney(msrp) + '</s></div>';
                  if (paFpv != null && map_no_promos > paFpv ) html += '<div class="boost-list-price"><span>Sale price: </span><s>' + Utils.formatMoney(map_no_promos) + '</s></div>';
                  if (msrp != null && paFpv != null) html += '<div class="boost-savings"><span>Save: </span><span>' + Utils.formatMoney(msrp  - paFpv) + '  (' + Math.floor((msrp  - paFpv) * 100 / msrp) + '%)</span></div>';
                  if (isLower) {
                   html += '<span class="low_cart">See Lower Price in Cart</span><div class="boost-custom-tooltip"> ? <span class="boost-custom-tooltiptext">Find out by adding the product to the cart.</span></div>;' 
                  } else {
                  	html += '<div class="boost-price"><span>Our price: </span><span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(paFpv) + '</span></div>';
                  }
              } else {
                  if (data.price_min != data.price_max) {
                      html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' ' + '</span>';
                  }
                  if (isLower) {
                  	if (msrp != null) html += '<div class="boost-list-price"><span>List price: </span><s>' + msrp + '</s></div>'
                    html += '<span class="low_cart">See Lower Price in Cart</span><div class="boost-custom-tooltip"> ? <span class="boost-custom-tooltiptext">Find out by adding the product to the cart.</span></div>;' 
                  } else {
                  if (msrp != null && msrp > paFpv) html += '<div class="boost-list-price"><span>List price: </span><s>' + Utils.formatMoney(msrp) + '</s></div>'
                  html += '<div class="boost-price"><span>Our price: </span><span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(paFpv) + '</span></div>';
                  } 
              }
		return html;
    } */ 
    
	function buildprice(data) {
		var html = '';
        html = '<div class="boost-pfs-filter-product-item-price">';
        

        var comparePrice = data.compare_at_price_min;
        var price = data.price_min;

        var onSale = comparePrice > price;
        var priceVaries = data.price_max > data.price_min;

        var msrp = Utils.getProductMetafield(data, 'TownApplianceAPI', 'msrp');//(msrp metafield) /// List price
        if (msrp != null) {
          msrp = msrp.replace(/\$/g, '').replace(/,/g, '')
          msrp = msrp*1;

          if (!comparePrice) {
            comparePrice = msrp;
            onSale = true;                
          }
        }

        var paFpv = Utils.getProductMetafield(data, 'TownApplianceAPI', 'pafpv_price');// website price (metafield)
        if (paFpv != null) {
          paFpv =  paFpv.replace(/\$/g, '').replace(/,/g, '')
          paFpv =  paFpv*1;

          price = paFpv;
        }


        var isLower = false;
        if (paFpv && data.price_min < paFpv) { 
          isLower = true;
        }

        if (onSale) {
          html += '<div class="boost-list-price"><span>List price: </span><s>' + Utils.formatMoney(comparePrice) + '</s></div>';

          if (data.compare_at_price_min > 0 && !isLower) {
            var percentageSaved = Math.floor((comparePrice  - price) * 100 / comparePrice)
            if (percentageSaved >= 5) html += '<div class="boost-savings"><span>Save: </span><span>' + Utils.formatMoney(comparePrice  - price) + '  (' + percentageSaved + '%)</span></div>';
          }
        } else {
          if (priceVaries) {
            html += '<span class="boost-pfs-filter-product-item-price-from-text">From</span>';
          }
        }

        html += '<div class="boost-price"><span>Our price: </span><span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(price) + '</span></div>';

        if (isLower) {
          html += '<div style="display: flex; position: relative; flex-direction: row-reverse;"><span class="low_cart" style="margin-right: 5px;">See Lower Price in Cart</span><div class="boost-custom-tooltip"> ? <span class="boost-custom-tooltiptext">Find out by adding the product to the cart.</span></div></div>'; 
        } 

        html += '<div class="boost-rebates">{{itemRebates}}</div>'
    
        html += '</div>';

		return html;
	}
  

	InstantSearchMobile.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
		if (!searchBoxId) searchBoxId = this.searchBoxId;
		// Hide debut's search bar on mobile, and show our search bar instead
		if(jQ('.js-drawer-close').length > 0){
			setTimeout(function() {
				jQ('.js-drawer-close').trigger('click');
			});
		}
	};

	SearchInput.prototype.customizeInstantSearch= function() {
		// Hide debut's search suggestion
		if (jQ('.predictive-search-wrapper').length > 0){
				jQ('.predictive-search-wrapper').hide();
		}
	};

	function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
		/* console.log('closeSuggestionMobile'); */
		jQ(searchBoxId).autocomplete('close');
		jQ('.' + Class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
		// Remove search box
		var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
		if (isCloseSearchBox) jQ('.boost-pfs-search-suggestion-mobile-top-panel,.boost-pfs-search-suggestion-mobile-overlay').hide();
		// Update current term for all search boxes
		setValueAllSearchBoxes();
		// Add back tabindex=-1
		jQ('.boost-pfs-search-no-tabindex').attr('tabindex', -1);
		// Return scrolling of body
		if(jQ('body').hasClass(Class.searchSuggestionMobileOpen)){    
			jQ('body').removeClass(Class.searchSuggestionMobileOpen);
		}
		BoostPFS.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
	
		// Close search theme debut
		if(jQ('.js-drawer-close').length > 1){
			jQ('.js-drawer-close').trigger('click');
		}
	}
})();